import * as Cookie from 'js-cookie';
import { IServices } from 'lego-on-react';

import { Tld } from '../../typings/common';
import { UrlHelpers } from '../UrlHelpers';

const tld = UrlHelpers.getTld();
const tldForServices = tld === Tld.comTr ? 'tr' : tld;

export const GlobalSettings = {
    // tslint:disable-next-line
    accountsUrl: `${IServices.serviceUrl('pass', tldForServices)}/accounts`,
    passportUrl: IServices.serviceUrl('passport', tldForServices),
    yu: Cookie.get('yandexuid')
};
